import styled from 'styled-components';
import i18n from 'src/utils/translate';
import { helpScoutArticle } from 'src/utils/helpScoutBeacon';
import SearchBar from 'src/modules/search/shared/components/searchBar';
import SearchNavbar from 'src/modules/search/shared/components/searchNavbar';
import SearchResultsList from 'src/modules/search/posts/components/searchResultsList';
import SearchCommunitiesList from 'src/modules/search/communities/components/searchCommunitiesList';
import SearchTips from 'src/modules/search/shared/components/searchTips';
import Button from 'src/components/buttons/button';
import { titleLarge } from 'styles-js/mixins/typography';
import { SearchType } from 'src/constants/types';

type Props = {
  query: string;
  searchType: SearchType;
};
export default function SearchWrapper({ query, searchType }: Props) {
  return (
    <div className="search">
      <Header data-testid="search-page-container">
        <H1>{i18n.t('Search')} HealthUnlocked</H1>
        <SearchBar
          autoFocus={true}
          className="search-bar--global"
          customId="-row"
          searchType={searchType}
        />
        <StyledButton
          icon="open-right"
          iconLeftAligned={false}
          type="link"
          onClick={() => helpScoutArticle('139-different-types-of-search-on-healthunlocked')}
        >
          {i18n.t('Learn more about the search tool')}
        </StyledButton>
        <NavbarContainer>
          <SearchNavbar query={query} searchType={searchType} />
        </NavbarContainer>
      </Header>
      {query
        ? <SearchResultsListType searchType={searchType} />
        : <SearchTips isNoQuery={true} searchType={searchType} />
      }
    </div>
  );
}

function SearchResultsListType({ searchType }: { searchType: SearchType }) {
  switch (searchType) {
    case 'communities':
      return <SearchCommunitiesList />;
    case 'posts':
    default:
      return <SearchResultsList />;
  }
}

const Header = styled.div`
  max-width: 1200px;
  margin: 50px auto 40px;
  padding: 0 15px;
  background-color: ${({ theme }) => theme.colorWhite};

  @media (${({ theme }) => theme.underScreenXlarge}) and (${({ theme }) => theme.overScreenSmall}) {
    margin-left: 20px;
  }
  @media (${({ theme }) => theme.underScreenSmall}) {
    margin-bottom: 30px;
  }
`;

const H1 = styled.h1`
  ${titleLarge};
  margin: 0 0 15px;
`;

const StyledButton = styled(Button)`
  margin: 0;
`;

const NavbarContainer = styled.div`
  margin-top: 30px;
`;
